import { conf } from "./configuration.js";

// /////////////////////////////////////////////////////////////////////////////
// data
// /////////////////////////////////////////////////////////////////////////////

const hostname = window.location.hostname;
export const data = createBaseData(hostname);

/**
 * @arg {String} hostname
 */
function createBaseData(hostname) {
  const data = {
    get environment() {
      if (/pagerduty\.com/.test(hostname) || /pagerduty\.co\.jp/.test(hostname))
        return "production";
      else if (/pd-staging/.test(hostname)) return "pdstaging";
      return "development";
    },
    googleAnalyticsId: conf.googleAnalyticsId,
    get segmentWriteKey() {
      return conf.segmentWriteKey[data.environment];
    },
  };

  return data;
}
